document.addEventListener('DOMContentLoaded', () => {
  const video = document.querySelector('.js-hero-video');
  const externalVideo = document.querySelector('.js-hero-external-video');

  if (video) {
    const backdropVideo = document.querySelector('.js-hero-video-backdrop');
    video.addEventListener('click', playOrPause);

    // On keydown event to stop spacebar from scrolling the page
    video.addEventListener('keydown', (event) => {
      event.preventDefault();
      if (event.code === 'Space') {
        playOrPause();
        return;
      }
    });

    function playOrPause() {
      if (video.paused) {
        video.play();
        backdropVideo.play();
      } else {
        video.pause();
        backdropVideo.pause();
      }
    }
  }

  if (externalVideo) {
    const iframe = externalVideo.querySelector('iframe');
    const clickableArea = externalVideo.querySelector(
      '.hero-with-video-background__placeholder-content'
    );

    if (clickableArea) {
      clickableArea.addEventListener('click', () => {
        console.log('click');
        var iframeSrc = iframe.src;

        if (iframeSrc.includes('?')) {
          iframeSrc += '&autoplay=1';
        } else {
          iframeSrc += '?autoplay=1';
        }

        iframe.src = iframeSrc;
        externalVideo.classList.add('showVideo');
      });
    }
  }
});
